function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M20.5 6.667c-7.548 0-13.667 5.97-13.667 13.333s6.12 13.333 13.667 13.333S34.167 27.364 34.167 20 28.048 6.667 20.5 6.667zm-.042 10h.083c.92 0 1.667.746 1.667 1.667v8.333c0 .92-.746 1.667-1.667 1.667h-.083c-.92 0-1.667-.746-1.667-1.667v-8.333c0-.92.746-1.667 1.667-1.667zM20.5 15c-.943 0-1.708-.746-1.708-1.667s.765-1.667 1.708-1.667 1.708.746 1.708 1.667S21.443 15 20.5 15z",
  id: "A"
}), /*#__PURE__*/React.createElement("path", {
  id: "B",
  d: "M81.077 58.77c.637 0 1.154.517 1.154 1.154v2.308c0 .637-.517 1.154-1.154 1.154s-1.154-.517-1.154-1.154v-2.308c0-.637.517-1.154 1.154-1.154z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-6 -6)",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#d8ddeb",
  x: 13,
  y: 79.538,
  width: 150,
  height: 2.308,
  rx: 1.154
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#b3becd",
  x: 38.385,
  y: 23,
  width: 45,
  height: 57.692,
  rx: 1.319
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.308 23h13.846v10.22a1.32 1.32 0 0 1-1.319 1.319h-11.21a1.32 1.32 0 0 1-1.319-1.319V23z",
  fill: "#f5f8fa"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.242 23h28.516a1.32 1.32 0 0 1 1.319 1.319v56.374H21.242a1.32 1.32 0 0 1-1.319-1.319V24.32A1.32 1.32 0 0 1 21.242 23z",
  fill: "#d8ddeb"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#b3becd",
  x: 118,
  y: 55.308,
  width: 36.923,
  height: 25.385,
  rx: 1.319
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.23 55.308h6.923v7.912a1.32 1.32 0 0 1-1.319 1.319h-4.286a1.32 1.32 0 0 1-1.319-1.319v-7.912z",
  fill: "#f5f8fa"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.703 55.308h20.44a1.32 1.32 0 0 1 1.319 1.319v24.066h-21.758a1.32 1.32 0 0 1-1.319-1.319V56.626a1.32 1.32 0 0 1 1.319-1.319z",
  fill: "#d8ddeb"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#82ddff",
  x: 101.846,
  y: 46.077,
  width: 28.846,
  height: 34.615,
  rx: 1.319
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.23 46.077h9.23v10.22a1.32 1.32 0 0 1-1.319 1.319h-6.593a1.32 1.32 0 0 1-1.319-1.319v-10.22zm-43.68 0h34.286a1.32 1.32 0 0 1 1.319 1.319v33.297H67.23V47.396a1.32 1.32 0 0 1 1.319-1.319z",
  fill: "#ccf1ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.923 55.308h11.538a2.31 2.31 0 0 1 2.308 2.308v6.923a2.31 2.31 0 0 1-2.308 2.308H79.923a2.31 2.31 0 0 1-2.308-2.308v-6.923a2.31 2.31 0 0 1 2.308-2.308z",
  fill: "#82ddff"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#f3fcff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#B"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#B",
  x: 4.615
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#B",
  x: 9.231
})), /*#__PURE__*/React.createElement("path", {
  d: "M78.77 69.154h13.846c.637 0 1.154.517 1.154 1.154s-.517 1.154-1.154 1.154H78.77c-.637 0-1.154-.517-1.154-1.154s.517-1.154 1.154-1.154z",
  fill: "#82ddff"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#2e3545",
  transform: "matrix(-1 0 0 -1 41 40)",
  xlinkHref: "#A"
}));

function SvgPendingPackagesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 157,
    height: 76,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgPendingPackagesIcon);
export default __webpack_public_path__ + "static/media/pending-packages-icon.0762630f.svg";
export { ForwardRef as ReactComponent };